import Auth from '@aws-amplify/auth';

const config = process.env;
export class AuthService {
  private static auth = Auth;

  public static configure = () =>
    AuthService.auth.configure({
      userPoolId: config.REACT_APP_AWS_USER_POOL_ID,
      userPoolWebClientId: config.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
      region: config.REACT_APP_AWS_REGION,
      cookieStorage: {
        domain: process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_DOMAIN,
        path: '/',
        expires: 365,
        secure: true,
        sameSite: 'lax',
      },
    });

  public static configureCognitoForWorker = () =>
    AuthService.auth.configure({
      userPoolId: config.REACT_APP_AWS_USER_POOL_ID,
      userPoolWebClientId: config.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
      region: config.REACT_APP_AWS_REGION,
      cookieStorage: {
        domain: process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_DOMAIN,
        path: '/worker-portal',
        expires: 365,
        secure: true,
        sameSite: 'lax',
      },
    });

  /**
   * Rejects with the bare string 'No current user' when nobody is signed in, so an
   * unhandled rejection here reaches Sentry as an error. Prefer getSessionSafe() where
   * being signed out is an expected state.
   */
  public static getSession = () => AuthService.auth.currentSession();

  public static getSessionSafe = async () => {
    try {
      return await AuthService.auth.currentSession();
    } catch (error) {
      console.debug('No active Cognito session:', error);
      return null;
    }
  };

  public static isSignedIn = () => AuthService.auth.currentAuthenticatedUser();

  public static signIn = ({ username, password }) => AuthService.auth.signIn(username, password);

  public static signOutGlobal = () => AuthService.auth.signOut({ global: true });

  public static signOut = () => AuthService.auth.signOut();

  public static changePassword = async (oldPassword: string, newPassword: string) => {
    const user = await AuthService.auth.currentAuthenticatedUser();
    return AuthService.auth.changePassword(user, oldPassword, newPassword);
  };
}
